/**
 * Service: Profiles
 * Wraps user profile queries.
 */
import { supabase } from "@/integrations/supabase/client";

export async function getProfileCount() {
  return supabase.from("profiles").select("id", { count: "exact", head: true });
}

export async function getProfilesByUserIds(userIds: string[]) {
  return supabase
    .from("profiles")
    .select("user_id, email, first_name, last_name")
    .in("user_id", userIds);
}

/**
 * Own-row read of the account default (name + delivery address). RLS scopes
 * this to the caller; the editor writes back through the RPC below, never
 * directly to the table.
 */
export async function getOwnProfileDetails(userId: string) {
  return supabase
    .from("profiles")
    .select("first_name, last_name, postal_address")
    .eq("user_id", userId)
    .order("created_at", { ascending: true })
    .limit(1)
    .maybeSingle();
}

/**
 * SECURITY DEFINER, own-row only, fully normalises the address (no
 * region+state hybrids) and writes one audit row per changed field.
 */
export async function updateProfileDetails(input: {
  firstName: string;
  lastName: string;
  postalAddress: Record<string, string> | null;
}) {
  return supabase.rpc("update_own_profile_details", {
    p_first_name: input.firstName,
    p_last_name: input.lastName,
    p_postal_address: (input.postalAddress ?? null) as never,
  });
}
